module.exports = __webpack_public_path__ + "static/media/card-gator-protect-mobile-br.68993f55.png";